import React, { Component, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MaterialUISelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';

import dagstorp from 'LegacyWeployDesignLanguage/dagstorp';

const BootstrapInput = withStyles(() => ({
  input: {
    width: 'auto',
    border: 'none',
    '&:focus': {
      border: 'none',
      background: 'transparent',
    },
  },
}))(InputBase);

const commonRootStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  border: 'none',
  paddingRight: dagstorp.spacing[3],
  fontFamily: 'Assistant, sans-serif',
  fontWeight: 700,
};

const styles = theme => ({
  root: {
    ...commonRootStyles,
    width: '100%',
  },
  textRoot: {
    ...commonRootStyles,
    width: 'auto',
  },
  formControl: {
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      right: 0,
      zIndex: -1,
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  filled: {
    width: '100%',
  },
  focused: {
    color: dagstorp.colors.text.primary,
    width: 'auto',
    '&:before': {
      border: 0,
    },
    '&:hover': {
      border: 0,
      cursor: 'pointer',
    },
    ...dagstorp.typography.button,
    fontSize: '16px',
  },
});

const OUTLINED = 'OUTLINED';
const TEXT = 'TEXT';

const StyledOption = styled(MenuItem)`
  padding: 1em;
  font-family: "Assistant", sans-serif;
`;

export const Option = forwardRef((props, ref) => (<StyledOption ref={ref} {...props} />));

class Select extends Component {
  state = {
    labelWidth: 0,
  };

  componentDidMount() {
    this.setState({ // eslint-disable-line
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth, // eslint-disable-line
    });
  }

  render() {
    const {
      classes,
      id,
      labelName,
      name,
      required,
      type,
      value,
      ...rest
    } = this.props;

    return (
      <FormControl className={classes.formControl}>
        <InputLabel
          variant="outlined"
          ref={(ref) => { this.InputLabelRef = ref; }}
          htmlFor={id}
          required={required}
        >
          {labelName}
        </InputLabel>
        <MaterialUISelect
          fullWidth
          {...rest}
          value={value}
          renderValue={displayValue => (type === OUTLINED ? displayValue : displayValue.toUpperCase())}
          input={
            type === OUTLINED
            ? (
              <OutlinedInput
                name={name}
                labelWidth={this.state.labelWidth}
                className={classes.filled}
                id={id}
              />
            )
            : (
              <BootstrapInput
                name={name}
                className={[classes.text, classes.focused].join(' ')}
                inputProps={{
                  classes: { root: classes.textRoot },
                }}
                id={id}
              />
            )
          }
        />
      </FormControl>
    );
  }
}

Select.Option = Option;

Select.propTypes = {
  value: PropTypes.string,
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  labelName: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.oneOf([OUTLINED, TEXT]),
};

Select.defaultProps = {
  value: '',
  required: false,
  type: OUTLINED,
  labelName: '',
};

Select.OUTLINED = OUTLINED;
Select.TEXT = TEXT;

export default withStyles(styles)(Select);
